// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const EquipmentsLoanList = lazy(() => import('../../views/equipmentsloan/list'))

const EquipmentsLoan = [
  {
    path: '/equipmentsloan/list',
    element: <EquipmentsLoanList />
  }
]

export default EquipmentsLoan
